import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getGrivencetype = () => {
  return http.get("/Grivence/GetGrivencetype", {
    headers: { Authorization: "Bearer " + token },
  });
};

const addGrivence = (data) => {
  return http.post("/Grivence/AddGrivence", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateGrivences = (data) => {
  return http.post("/Grivence/UpdateGrivences", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const deleteGrivences = (data) => {
  return http.post("/Grivence/DeleteGrivences", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getGrivencebyId = (data) => {
  return http.post("/Grivence/GetGrivencebyId", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getGrivenceList = (data) => {
  return http.post("/Grivence/GetGrivenceList", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const sortbyTime = (data) => {
  return http.post("/Grivence/SortbyTime", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const grivencesSort = (data) => {
  return http.post("/Grivence/GrivencesSort", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const grivenceFilter = (data) => {
  return http.post("/Grivence/GrivenceFilter", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateGrivencessts = (data) => {
  return http.post("/Grivence/UpdateGrivences_sts", data, {
    headers: { Authorization: "Bearer " + token },
  });
};



const GrievenceService = {
  getGrivencetype,
  addGrivence,
  updateGrivences,
  deleteGrivences,
  getGrivencebyId,
  getGrivenceList,
  sortbyTime,
  grivencesSort,
  grivenceFilter,
  updateGrivencessts,
};

export default GrievenceService;
